// extracted by css-extract-rspack-plugin
var _1 = "EP_OUQvcMCorXBRc";
var _2 = "TaizSMmwz00J4BiH";
var _3 = "Tz5HeA7pLi4x_UIi";
var _4 = "jLDu3cSEa6UdAm4c";
var _5 = "UEMv61FiRmkISa4h";
var _6 = "wvwTx4I7OmAQwthX";
export { _1 as "content", _2 as "scrollBottomShadow", _3 as "scrollShadow", _4 as "scrollShadowHide", _5 as "scrollTopShadow", _6 as "wrapper" }
